export const ADDITIONAL_NAVIGATION = {
  "/pagalba-ukrainai/savanoryste": [
    {
      pathname: `/pagalba-ukrainai/aukojimas/`,
      title: `Aukojimas`,
    },
  ],
  "/pagalba-ukrainai/aukojimas": [
    {
      pathname: `/pagalba-ukrainai/savanoryste/`,
      title: `Savanorystė`,
    },
  ],
  "/ua/dopomoha/pozhertvy": [
    {
      pathname: `/ua/dopomoha/volonterstvo/`,
      title: `Волонтерство`,
    },
  ],
  "/ua/dopomoha/volonterstvo": [
    {
      pathname: `/ua/dopomoha/pozhertvy/`,
      title: `Пожертви`,
    },
  ],
  "/en/support-ukraine/donation": [
    {
      pathname: `/en/support-ukraine/volunteering/`,
      title: `Volunteering`,
    },
  ],
  "/en/support-ukraine/volunteering": [
    {
      pathname: `/en/support-ukraine/donation/`,
      title: `Donation`,
    },
  ],

  // @todo: fix these links once we have all the slugs for personalized guide pages
  /* Personalized guides */
  /* Guide for new arrivals */
  "/guide-for-new-arrivals": [
    {
      pathname: `/guide-for-persons-with-children/`,
      title: `Guide for persons with children`,
    },
    {
      pathname: `/guide-for-persons-with-disabilities/`,
      title: `Guide for persons with disabilities`,
    },
  ],
  "/en/guide-for-new-arrivals": [
    {
      pathname: `/en/guide-for-persons-with-children/`,
      title: `Guide for persons with children`,
    },
    {
      pathname: `/en/guide-for-persons-with-disabilities/`,
      title: `Guide for persons with disabilities`,
    },
  ],
  "/ua/guide-for-new-arrivals": [
    {
      pathname: `/ua/guide-for-persons-with-children/`,
      title: `Guide for persons with children`,
    },
    {
      pathname: `/ua/guide-for-persons-with-disabilities/`,
      title: `Guide for persons with disabilities`,
    },
  ],

  /* Guide for persons with children */
  "/guide-for-persons-with-children": [
    {
      pathname: `/guide-for-persons-with-disabilities/`,
      title: `Guide for persons with disabilities`,
    },
    {
      pathname: `/guide-for-new-arrivals/`,
      title: `Guide for new arrivals`,
    },
  ],
  "/en/guide-for-persons-with-children": [
    {
      pathname: `/en/guide-for-persons-with-disabilities/`,
      title: `Guide for persons with disabilities`,
    },
    {
      pathname: `/en/guide-for-new-arrivals/`,
      title: `Guide for new arrivals`,
    },
  ],
  "/ua/guide-for-persons-with-children": [
    {
      pathname: `/ua/guide-for-persons-with-disabilities/`,
      title: `Guide for persons with disabilities`,
    },
    {
      pathname: `/ua/guide-for-new-arrivals/`,
      title: `Guide for new arrivals`,
    },
  ],

  /* Guide for persons with disabilities */
  "/guide-for-persons-with-disabilities": [
    {
      pathname: `/guide-for-new-arrivals/`,
      title: `Guide for new arrivals`,
    },
    {
      pathname: `/guide-for-persons-with-children/`,
      title: `Guide for persons with children`,
    },
  ],
  "/en/guide-for-persons-with-disabilities": [
    {
      pathname: `/en/guide-for-new-arrivals/`,
      title: `Guide for new arrivals`,
    },
    {
      pathname: `/en/guide-for-persons-with-children/`,
      title: `Guide for persons with children`,
    },
  ],
  "/ua/guide-for-persons-with-disabilities": [
    {
      pathname: `/ua/guide-for-new-arrivals/`,
      title: `Guide for new arrivals`,
    },
    {
      pathname: `/ua/guide-for-persons-with-children/`,
      title: `Guide for persons with children`,
    },
  ],
};
